import React, { useMemo, useCallback } from 'react';

const Pagination = ({ currentPage, totalPages, items, limit, handlePageChange }) => {
    // const showingFrom = useMemo(() => (currentPage - 1) * limit + 1, [currentPage, limit]);
    // const showingTo = useMemo(() => Math.min(currentPage * limit, items), [currentPage, limit, items]);
    const handleClick = useCallback((page) => {
        if (page >= 1 && page <= totalPages) {
            handlePageChange(page);
        }
    }, [totalPages, handlePageChange]);

    const pageNumbers = useMemo(() => Array.from({ length: totalPages }, (_, i) => i + 1), [totalPages]);

    return (
        <div className="d-flex justify-content-between align-items-center gap-3 mt-4 mb-0">
            <div className="pagination-info">
                {/* <p>Showing {showingFrom} to {showingTo} of {items} entries</p> */}
            </div>
            <div className="pagination_navbar">
                <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end mb-0">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => handleClick(currentPage - 1)}>Prev</button>
                        </li>
                        {/* {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => handleClick(page)}>{page}</button>
                            </li>
                        ))} */}

                        {totalPages <= 5 ? (
                            pageNumbers.map((page) => (
                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handleClick(page)}>{page}</button>
                                </li>
                            ))
                        ) : (
                            <>
                                {/* Always show the first page */}
                                <li className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handleClick(1)}>1</button>
                                </li>

                                {/* Show dots if currentPage > 3 */}
                                {currentPage > 3 && (
                                    <li className="page-item disabled">
                                        <span className="page-link">...</span>
                                    </li>
                                )}

                                {/* Show middle pages */}
                                {[
                                    currentPage - 1,
                                    currentPage,
                                    currentPage + 1
                                ].filter(page => page > 1 && page < totalPages).map((page) => (
                                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handleClick(page)}>{page}</button>
                                    </li>
                                ))}

                                {/* Show dots if currentPage is not near the end */}
                                {currentPage < totalPages - 2 && (
                                    <li className="page-item disabled">
                                        <span className="page-link">...</span>
                                    </li>
                                )}

                                {/* Always show the last page */}
                                <li className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handleClick(totalPages)}>{totalPages}</button>
                                </li>
                            </>
                        )}
                        {/* {pageNumbers.map((page) => (
                            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => handleClick(page)}>{page}</button>
                            </li>
                        ))} */}
                        <li className={`page-item ${(currentPage === totalPages || totalPages === 0) ? 'disabled' : ''}`}>
                            <button className="page-link" onClick={() => handleClick(currentPage + 1)}>Next</button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default Pagination;
